import { ProductFeatureIconList, ProductFeatureIconName } from '@oy/uiicon';
import { productIconName, productName } from 'src/constants/AutoReport';

export const getIcon = (product_name: string): ProductFeatureIconName => {
  const productNameToLower = product_name.toLowerCase();
  if (
    ProductFeatureIconList.includes(
      productNameToLower as ProductFeatureIconName,
    )
  ) {
    return productNameToLower as ProductFeatureIconName;
  }

  return productIconName[product_name ?? ''] ?? 'our-services';
};

export const getProductName = (product_name: string): string => {
  return (
    productName[product_name ?? ''] ??
    `common_txProduct_${product_name.toLowerCase()}`
  );
};
